import api from '@/services/api'
import { mapDealFromApi, stagePatchPayload } from '@/adapters/deals'
import type { Deal, DealStage } from '@/types'
import type { StageQualificationPayload } from './dealStageTransitionFlow'

export async function patchDealStage(
  dealId: string,
  targetStage: DealStage,
  extra?: StageQualificationPayload & Record<string, unknown>,
): Promise<Deal> {
  const { data } = await api.patch(`/deals/${dealId}/stage`, stagePatchPayload(targetStage, extra))
  return mapDealFromApi(data.data ?? data)
}
